import React from "react"

const EquipTable = ({ data: { title = null, table }, className }) => {
  let maxRow = 0

  for (let row of table) {
    if (row.length > maxRow) {
      maxRow = row.length
    }
  }

  let isConfigured = false

  return (
    <table className={`equip-table ${className ? className : ''}`}>
      {title && <caption>{title}</caption>}
      <tbody>
        {table.map((row, id) => {
          const isMaxRow = row.length === maxRow
          const autoColspan = maxRow - row.length + 1
          isConfigured = Number.isInteger(isConfigured) ? isConfigured - 1 : false

          return (
            <tr key={id}>
              {row.map((cell, index, array) => {
                const withSet = Array.isArray(cell)

                if (withSet) {
                  const [text, colspan, rowspan] = cell
                  isConfigured = rowspan ? rowspan : true

                  return (
                    <td
                      key={index}
                      colSpan={colspan}
                      rowSpan={rowspan}
                    >
                      {text.getHTML()}
                    </td>
                  )
                } else {
                  return (
                    <td
                      key={index}
                      colSpan={isConfigured || isMaxRow ? null : (index !== array.length - 1) ? null : autoColspan}
                    >
                      {cell.getHTML()}
                    </td>
                  )
                }
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default EquipTable